
const state = {
}
// 修改状态
const mutations = {

}

// 执行异步
const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
